module.exports = __webpack_public_path__ + "static/img/bgHonor.f76d41bf.png";